import { createRouter, createWebHistory } from 'vue-router'
import FindTravelApp from '../components/client/FindTravelApp.vue'
import NotFound from '../components/common/NotFound.vue'

const companyName = import.meta.env.VITE_COMPANY_NAME

const routes = [
    {
        path: '/:pathMatch(.*)',
        component: NotFound,
        name: 'not-found',
        meta: {
            title: 'Woops'
        }
    },

    {
        path: '/test-fonts',
        component: () => import("@/components/testFonts.vue"),
        name: 'test-fonts',
        meta: {
            title: 'Test Fonts'
        }
    },

    {
        path: '/',
        component: () => import("@/components/user/auth/Login.vue"),
        name: 'user-login',
        meta: {
            title: 'Login'
        }
    },

    {
        path: '/forgot-password',
        component: () => import("@/components/user/auth/ForgotPassword.vue"),
        meta: {
            title: 'Forgot Password'
        }
    },

    {
        path: '/reset-password/:token',
        component: () => import("@/components/user/auth/ResetPassword.vue"),
        name: 'reset-password-form',
        meta: {
            title: 'Reset Password'
        }
    },

    {
        path: '/prize-cart',
        component: () => import("@/components/admin/prizes/SelectPrize.vue"),
        name: 'select-prize',
        meta: {
            title: 'Select Prize'
        }
    },

    {
        path: '/admin/login',
        component: () => import("@/components/admin/auth/AdminLogin.vue"),
        name: 'admin-login',
        meta: {
            title: 'Admin Login'
        }
    },

    {
        path: '/admin',
        component: () => import("@/components/admin/common-components/AdminDashboard.vue"),
        children: [

            {
                path: 'profile',
                component: () => import("@/components/admin/auth/Profile.vue"),
                name: 'profile',
                meta: {
                    title: 'Profile'
                }
            },

            {
                path: 'client-files',
                component: () => import("@/components/admin/client-files/ClientFilesList.vue"),
                name: 'client-files',
                meta: {
                    title: 'Client Files'
                }
            },

            {
                path: 'rate-analysis',
                component: () => import("@/components/admin/rate-analysis/Checker.vue"),
                name: 'rate-analysis',
                meta: {
                    title: 'Rate Analysis'
                }
            },

            {
                path: 'fit-finalisation-tracker',
                component: () => import("@/components/admin/fit-finalisation-tracker/FITFinalisation.vue"),
                name: 'fit-finalisation',
                meta: {
                    title: 'Fit Finalisation'
                }
            },

            {
                path: 'client-files/add',
                component: () => import("@/components/admin/client-files/ClientFilesAdminAdd.vue"),
                name: 'add-client-file',
                meta: {
                    title: 'Create Client File'
                }
            },

            {
                path: 'client-files/:id',
                name: 'edit-client-file',
                component: () => import("@/components/admin/client-files/ClientFilesAdminEdit.vue"),
                meta: {
                    title: 'Update Client File'
                }
            },

            {
                path: 'client-files/itinerary/:id',
                component: () => import("@/components/admin/itinerary-editing/ItineraryEditor.vue"),
                name: 'itinerary-edit',
                meta: {
                    title: 'Edit'
                }
            },

            {
                path: 'client-files/invoices/:id',
                name: 'invoices',
                component: () => import("@/components/admin/client-files/Invoices.vue")
            },

            {
                path: 'client-files/yield/:id',
                name: 'yield',
                component: () => import("@/components/admin/yield/Yield.vue")
            },

            {
                path: 'client-files/day-headers/:id',
                name: 'day-headers',
                component: () => import("@/components/admin/client-files/DayHeaders.vue")
            },

            {
                path: 'customers',
                name: 'customers',
                component: () => import("@/components/admin/customers/Index.vue"),
                children: [
                    {
                        path: '',
                        component: () => import("@/components/admin/customers/CustomerList.vue"),
                        name: 'customer-list',
                        meta: {
                            title: 'Customers'
                        }
                    },

                    {
                        path: 'customers/:id',
                        component: () => import("@/components/admin/customers/CustomerFilesList.vue"),
                        name: 'customer-files',
                        meta: {
                            title: 'Customer Files'
                        }
                    }
                ]
            },

            {
                path: 'quick-quote',
                name: 'quick-quote',
                component: () => import("@/components/admin/quick-quote/QuickQuote.vue"),
                children: [
                    {
                        path: '',
                        name: 'list-quick-quote-services',
                        component: () => import("@/components/admin/quick-quote/QuickQuoteServiceList.vue"),
                        meta: {
                            title: 'Quick Quote Services'
                        }
                    },

                    {
                        path: ':id',
                        name: 'QuickQuoteService',
                        component: () => import("@/components/admin/quick-quote/QuickQuoteServiceEdit.vue"),
                        meta: {
                            title: 'Edit Quick Quote Service'
                        }
                    },

                    {
                        path: 'add',
                        name: 'add-service',
                        component: () => import("@/components/admin/quick-quote/QuickQuoteServiceAdd.vue"),
                        meta: {
                            title: 'Add Quick Quote Service'
                        }
                    },

                    {
                        path: 'test',
                        name: 'test-packages' +
                            '',
                        component: () => import("@/components/admin/quick-quote/TestPackages.vue"),
                        meta: {
                            title: 'Test Quick Quote Packages'
                        }
                    }
                ]
            },

            {
                path: 'users',
                name: 'users',
                component: () => import("@/components/admin/users/Users.vue"),
                children: [
                    {
                        path: '',
                        name: 'list-users',
                        component: () => import("@/components/admin/users/UserList.vue"),
                        meta: {
                            title: 'Users'
                        }
                    }
                ]
            },

            {
                path: 'agents',
                name: 'agents',
                component: () => import("@/components/admin/agents/Agents.vue"),
                children: [
                    {
                        path: '',
                        name: 'list-agents',
                        component: () => import("@/components/admin/agents/AgentList.vue"),
                        meta: {
                            title: 'Agents'
                        }
                    },


                    {
                        path: 'add',
                        name: 'add-agent',
                        component: () => import("@/components/admin/agents/AgentAdd.vue"),
                        meta: {
                            title: 'Create Agent'
                        }
                    },

                    {
                        path: ':id',
                        name: 'agent',
                        component: () => import("@/components/admin/agents/AgentEdit.vue"),
                        meta: {
                            title: 'Edit Agent'
                        }
                    },
                ]
            },

            {
                path: 'admins',
                name: 'admins',
                component: () => import("@/components/admin/admins/Admins.vue")  ,
                children: [
                    {
                        path: '',
                        name: 'list-admins',
                        component: () => import("@/components/admin/admins/AdminList.vue"),
                        meta: {
                            title: 'Admin Users'
                        }
                    },

                    {
                        path: 'add',
                        name: 'add-admin',
                        component: () => import("@/components/admin/admins/AdminAdd.vue"),
                        meta: {
                            title: 'Create Admin'
                        }
                    },

                    {
                        path: ':id',
                        name: 'edit-admin',
                        component: () => import("@/components/admin/admins/AdminEdit.vue"),
                        meta: {
                            title: 'Edit Admin'
                        }
                    }
                ]
            },

            {
                path: 'suppliers',
                name: 'suppliers',
                component: () => import("@/components/admin/suppliers/Suppliers.vue"),
                children: [
                    {
                        path: '',
                        name: 'list-suppliers',
                        component: () => import("@/components/admin/suppliers/SupplierList.vue"),
                        meta: {
                            title: 'Suppliers'
                        }
                    },

                    {
                        path: 'add',
                        name: 'add-supplier',
                        component: () => import("@/components/admin/suppliers/SupplierAdd.vue"),
                        meta: {
                            title: 'Create Supplier'
                        }

                    },

                    {
                        path: ':id',
                        name: 'supplier',
                        component: () => import("@/components/admin/suppliers/SupplierEdit.vue"),
                        meta: {
                            title: 'Edit Supplier'
                        }

                    }
                ]

            },

            {
                path: 'client-alerts',
                name: 'client-alerts',
                component: () => import("@/components/admin/client-alerts/Index.vue"),
                children: [
                    {
                        path: '',
                        name: 'list-client-alerts',
                        component: () => import("@/components/admin/client-alerts/List.vue"),
                        meta: {
                            title: 'Client Alerts'
                        }
                    },

                    {
                        path: 'add',
                        name: 'add-client-alert',
                        component: () => import("@/components/admin/client-alerts/Add.vue"),
                        meta: {
                            title: 'Add Client Alert'
                        }
                    },

                    {
                        path: ':id',
                        name: 'edit-client-alert',
                        component: () => import("@/components/admin/client-alerts/Edit.vue"),
                        meta: {
                            title: 'Edit Client Alert'
                        }
                    }

                ]

            },

            {
                path: 'attachments',
                name: 'attachments',
                component: () => import("@/components/admin/supplier-attachments/SupplierAttachments.vue"),
                children: [
                    {
                        path: '',
                        name: 'list-attachments',
                        component: () => import("@/components/admin/supplier-attachments/SupplierAttachmentsList.vue"),
                        meta: {
                            title: 'Attachments'
                        }
                    },

                    {
                        path: 'add',
                        name: 'add-attachment',
                        component: () => import("@/components/admin/supplier-attachments/SupplierAttachmentAdd.vue"),
                        meta: {
                            title: 'Attachments'
                        }
                    },

                    {
                        path: ':id',
                        name: 'edit-attachment',
                        component: () => import("@/components/admin/supplier-attachments/SupplierAttachmentEdit.vue"),
                        meta: {
                            title: 'Attachments'
                        }
                    }

                ]

            },

            {
                path: 'labels',
                name: 'labels',
                component: () => import("@/components/admin/labels/Labels.vue"),
                children: [
                    {
                        path: '',
                        name: 'list-labels',
                        component: () => import("@/components/admin/labels/LabelList.vue"),
                        meta: {
                            title: 'FIT Booking Labels'
                        }
                    }

                ]

            },

            {
                path: 'passenger-alerts',
                name: 'alerts',
                component: () => import("@/components/admin/itinerary-alerts/ItineraryAlerts.vue"),
                children: [
                    {
                        path: '',
                        name: 'list-alerts',
                        component: () => import("@/components/admin/itinerary-alerts/ItineraryAlertList.vue"),
                        meta: {
                            title: 'Passenger Alerts'
                        }
                    },

                    {
                        path: 'add',
                        name: 'add-alert',
                        component: () => import("@/components/admin/itinerary-alerts/ItineraryAlertAdd.vue"),
                        meta: {
                            title: 'Alerts'
                        }
                    },

                    {
                        path: ':id',
                        name: 'edit-alert',
                        component: () => import("@/components/admin/itinerary-alerts/ItineraryAlertEdit.vue"),
                        meta: {
                            title: 'Alerts'
                        }
                    }

                ]

            },

            {
                path: 'day-headers',
                name: 'day-headers-content',
                component: () => import("@/components/admin/day-headers/Index.vue"),
                children: [
                    {
                        path: '',
                        name: 'list-day-headers',
                        component: () => import("@/components/admin/day-headers/List.vue"),
                        meta: {
                            title: 'Day Headers'
                        }
                    }
                ]

            },

            {
                path: 'point-of-interests',
                name: 'point-of-interests',
                component: () => import("@/components/admin/point-of-interests/Index.vue"),
                children: [
                    {
                        path: '',
                        name: 'list-point-of-interests',
                        component: () => import("@/components/admin/point-of-interests/List.vue"),
                        meta: {
                            title: 'Point of Interests'
                        }
                    },
                    {
                        path: 'add',
                        name: 'add-point-of-interest',
                        component: () => import("@/components/admin/point-of-interests/Add.vue"),
                        meta: {
                            title: 'Add Point of Interest'
                        }
                    },
                    {
                        path: ':id',
                        name: 'edit-point-of-interest',
                        component: () => import("@/components/admin/point-of-interests/Edit.vue"),
                        meta: {
                            title: 'Edit Point of Interest'
                        }
                    }
                ]

            },

            

            {
                path: 'restaurants',
                name: 'restaurants',
                component: () => import("@/components/admin/restaurants/Index.vue"),
                children: [
                    {
                        path: '',
                        name: 'list-restaurants',
                        component: () => import("@/components/admin/restaurants/List.vue"),
                        meta: {
                            title: 'Restaurants'
                        }
                    },
                    {
                        path: 'add',
                        name: 'add-restaurant',
                        component: () => import("@/components/admin/restaurants/Add.vue"),
                        meta: {
                            title: 'Add Restaurant'
                        }
                    },
                    {
                        path: ':id',
                        name: 'edit-restaurant',
                        component: () => import("@/components/admin/restaurants/Edit.vue"),
                        meta: {
                            title: 'Edit Restaurant'
                        }
                    }
                ]

            },

            {
                path: 'itinerary-locations',
                name: 'itinerary-locations',
                component: () => import("@/components/admin/itinerary-locations/ItineraryLocations.vue"),
                children: [
                    {
                        path: '',
                        name: 'list-locations',
                        component: () => import("@/components/admin/itinerary-locations/ItineraryLocationList.vue"),
                        meta: {
                            title: 'Itinerary Locations'
                        }
                    },

                    {
                        path: 'add',
                        name: 'add-location',
                        component: () => import("@/components/admin/itinerary-locations/ItineraryLocationAdd.vue"),
                        meta: {
                            title: 'Add Location'
                        }
                    },

                    {
                        path: ':id',
                        name: 'edit-location',
                        component: () => import("@/components/admin/itinerary-locations/ItineraryLocationEdit.vue"),
                        meta: {
                            title: 'Edit Location'
                        }
                    }

                ]

            },

            {
                path: 'itinerary-options',
                name: 'itinerary-options',
                component: () => import("@/components/admin/itinerary-options/ItineraryOptions.vue"),
                children: [
                    {
                        path: '',
                        name: 'list-itinerary-options',
                        component: () => import("@/components/admin/itinerary-options/ItineraryOptionList.vue"),
                        meta: {
                            title: 'Itinerary Options'
                        }
                    },
                    {
                        path: 'add',
                        name: 'add-option',
                        component: () => import("@/components/admin/itinerary-options/ItineraryOptionAdd.vue"),
                        meta: {
                            title: 'Add Option'
                        }
                    },
                    {
                        path: ':id',
                        name: 'edit-option',
                        component: () => import("@/components/admin/itinerary-options/ItineraryOptionEdit.vue"),
                        meta: {
                            title: 'Edit Option'
                        }
                    }
                ]

            },

            {
                path: 'itinerary-suppliers',
                name: 'itinerary-suppliers',
                component: () => import("@/components/admin/itinerary-suppliers/ItinerarySuppliers.vue"),
                children: [
                    {
                        path: '',
                        name: 'list-itinerary-suppliers',
                        component: () => import("@/components/admin/itinerary-suppliers/ItinerarySupplierList.vue"),
                        meta: {
                            title: 'Itinerary Suppliers'
                        }
                    },
                    {
                        path: 'add',
                        name: 'add-itinerary-supplier',
                        component: () => import("@/components/admin/itinerary-suppliers/ItinerarySupplierAdd.vue"),
                        meta: {
                            title: 'Add Supplier'
                        }
                    },
                    {
                        path: ':id',
                        name: 'edit-supplier',
                        component: () => import("@/components/admin/itinerary-suppliers/ItinerarySupplierEdit.vue"),
                        meta: {
                            title: 'Edit Supplier'
                        }
                    }
                ]

            },

            {
                path: 'itinerary-galleries',
                name: 'itinerary-galleries',
                component: () => import("@/components/admin/itinerary-galleries/ItineraryGalleries.vue"),
                children: [
                    {
                        path: '',
                        name: 'list-itinerary-galleries',
                        component: () => import("@/components/admin/itinerary-galleries/ItineraryGalleryList.vue"),
                        meta: {
                            title: 'Itinerary Galleries'
                        }
                    },
                    {
                        path: 'add/:code?',
                        name: 'add-gallery',
                        component: () => import("@/components/admin/itinerary-galleries/ItineraryGalleryAdd.vue"),
                        meta: {
                            title: 'Add Gallery'
                        }
                    },
                    {
                        path: ':id',
                        name: 'edit-gallery',
                        component: () => import("@/components/admin/itinerary-galleries/ItineraryGalleryEdit.vue"),
                        meta: {
                            title: 'Edit Gallery'
                        }
                    }
                ]

            },

            {
                path: 'guide',
                name: 'admin-guide',
                component: () => import("@/components/admin/guide/AdminGuide.vue"),
                children: [
                    {
                        path: '',
                        name: 'admin-guide-index',
                        component: () => import("@/components/admin/guide/AdminGuideIndex.vue")
                    },
                    {
                        path: ':id',
                        name: 'admin-guide-article',
                        component: () => import("@/components/admin/guide/AdminGuideArticle.vue"),
                        meta: {
                            title: 'User Guide'
                        }
                    }
                ]
            },

            {
                path: 'payments',
                name: 'payments',
                component: () => import("@/components/admin/payments/Payments.vue"),
                children: [
                    {
                        path: '',
                        name: 'list-payments',
                        component: () => import("@/components/admin/payments/PaymentList.vue"),
                        meta: {
                            title: 'Credit Card Payments'
                        }
                    },
                    {
                        path: 'add',
                        name: 'add-payment',
                        component: () => import("@/components/admin/payments/PaymentAdd.vue"),
                        meta: {
                            title: 'Payment'
                        }
                    },
                    {
                        path: 'edit/:id',
                        name: 'edit-payment',
                        component: () => import("@/components/admin/payments/PaymentEdit.vue"),
                        meta: {
                            title: 'Payment'
                        }
                    }

                ]

            },

            {
                path: 'regular-tours',
                name: 'regular-tours',
                component: () => import("@/components/admin/regular-tours/Departures.vue"),
                children: [
                    {
                        path: '',
                        name: 'regular-list',
                        component: () => import("@/components/admin/regular-tours/DepartureList.vue"),
                        meta: {
                            title: 'Regular Tours'
                        }
                    },
                    {
                        path: 'category-tour-list',
                        name: 'category-tour-list',
                        component: () => import("@/components/admin/regular-tours/components/CategoriesToursList.vue"),
                        meta: {
                            title: 'Regular Tours'
                        }
                    },
                    {
                        path: 'category-catalogue/:id',
                        name: 'category-catalogue',
                        component: () => import("@/components/admin/regular-tours/components/CategoryCatalogues.vue"),
                        meta: {
                            title: 'Regular Tours'
                        }
                    },
                    {
                        path: 'add',
                        name: 'add-regular-departure',
                        component: () => import("@/components/admin/regular-tours/Add.vue"),
                        meta: {
                            title: 'Regular Tours'
                        }
                    },
                    {
                        path: 'edit',
                        name: 'edit-regular-departure',
                        component: () => import("@/components/admin/regular-tours/Edit.vue"),
                        meta: {
                            title: 'Regular Tours'
                        }
                    }
                ]
            },

            {
                path: 'series-tours',
                name: 'series-tours',
                component: () => import("@/components/admin/series-tours/Index.vue"),
                children: [
                    {
                        path: '',
                        name: 'series-tour-list',
                        component: () => import("@/components/admin/series-tours/SeriesTourList.vue"),
                        meta: {
                            title: 'Series Tours'
                        }
                    },
                    {
                        path: 'add',
                        name: 'add-series-tour',
                        component: () => import("@/components/admin/series-tours/Add.vue"),
                        meta: {
                            title: 'Add Series Tour'
                        }
                    },
                    {
                        path: 'edit',
                        name: 'edit-series-tour',
                        component: () => import("@/components/admin/series-tours/Edit.vue"),
                        meta: {
                            title: 'Edit Series Tour'
                        }
                    },
                    {
                        path: 'requests',
                        name: 'series-requests',
                        component: () => import("@/components/admin/series-tours/SeriesTour.vue"),
                        meta: {
                            title: 'Series Requests'
                        }
                    },
                ]
            },

            {
                path: 'quote-packages',
                name: 'quote-packages',
                component: () => import("@/components/admin/packages/Index.vue"),
                children: [
                    {
                        path: '',
                        name: 'quote-package-list',
                        component: () => import("@/components/admin/packages/PackageList.vue"),
                        meta: {
                            title: 'Packages'
                        }
                    },
                    {
                        path: 'quote-package/:id',
                        name: 'quote-package-admin',
                        component: () => import("@/components/admin/packages/Package.vue"),
                        meta: {
                            title: 'Package'
                        }
                    },
                ]
            },

            {
                path: 'roles',
                name: 'roles',
                component: () => import("@/components/admin/permissions/Permissions.vue"),
                children: [
                    {
                        path: '',
                        name: 'list-roles',
                        component: () => import("@/components/admin/permissions/RolesList.vue"),
                        meta: {
                            title: 'Roles'
                        }
                    },

                    {
                        path: 'edit/:id',
                        name: 'edit-role',
                        component: () => import("@/components/admin/permissions/RoleEdit.vue"),
                        meta: {
                            title: 'Edit Role'
                        }
                    },

                    {
                        path: 'permissions',
                        name: 'list-permissions',
                        component: () => import("@/components/admin/permissions/PermissionsList.vue"),
                        meta: {
                            title: 'Permissions'
                        }
                    },

                ]
            },

            {
                path: 'insights',
                name: 'insights',
                component: () => import("@/components/admin/insights/Insights.vue")  ,
                children: [
                    {
                        path: '',
                        name: 'activities-overview',
                        component: () => import("@/components/admin/insights/ActivitiesOverview.vue"),
                        meta: {
                            title: 'Activities'
                        }
                    },

                    {
                        path: 'edited-services',
                        name: 'edited-services',
                        component: () => import("@/components/admin/insights/EditedServices.vue"),
                        meta: {
                            title: 'Edited Services'
                        }
                    }

                ]
            },

            {
                path: 'reviews',
                name: 'reviews',
                component: () => import("@/components/admin/service-reviews/ReviewList.vue"),
                meta: {
                    title: 'Reviews'
                }
            },

            {
                path: 'famil-feedback',
                name: 'famil-feedback',
                component: () => import("@/components/admin/famil-feedbacks/FeedbackList.vue"),
                meta: {
                    title: 'Famil Feedback'
                }
            },

            {
                path: 'email-content',
                name: 'email-content',
                component: () => import("@/components/admin/email-content/Index.vue"),
                children: [
                    {
                        path: '',
                        name: 'email-content-list',
                        component: () => import("@/components/admin/email-content/EmailContentList.vue"),
                        meta: {
                            title: 'Email Content List'
                        }
                    },

                    {
                        path: 'add',
                        name: 'add-email-content',
                        component: () => import("@/components/admin/email-content/EmailContentAdd.vue"),
                        meta: {
                            title: 'Add Email Content'
                        }
                    },

                    {
                        path: 'edit/:id',
                        name: 'edit-email-content',
                        component: () => import("@/components/admin/email-content/EmailContentEdit.vue"),
                        meta: {
                            title: 'Edit Email Content'
                        }
                    },
                ]
            },

            {
                path: 'prizes',
                name: 'prizes',
                component: () => import("@/components/admin/prizes/List.vue"),
                meta: {
                    title: 'Prizes'
                }
            },

            {
                path: 'settings',
                name: 'settings',
                component: () => import("@/components/admin/settings/Setup.vue"),
                meta: {
                    title: 'Environment Settings'
                }
            },

            {
                path: 'cf-ops-logs',
                name: 'cf-ops-logs',
                component: () => import("@/components/admin/audits/ClientFileOpsLogs.vue"),
                meta: {
                    title: 'FIT Finalisation Logs'
                }
            },
              
            {
                path: 'agent-branding',
                name: 'agent-branding',
                component: () => import("@/components/admin/agent-branding/Index.vue"),
                meta: {
                    title: 'Agent Branding'
                }
            },

            {
                path: 'fit-settings',
                name: 'fit-settings',
                component: () => import("@/components/admin/settings/FitSettings.vue"),
                meta: {
                    title: 'FIT Settings'
                }
            },

            {
                path: 'booking-settings',
                name: 'booking-settings',
                component: () => import("@/components/admin/settings/BookingSettings.vue"),
                meta: {
                    title: 'Booking Settings'
                }
            },

            {
                path: 'famil-agent-colors',
                name: 'famil-agent-colors',
                component: () => import("@/components/admin/settings/FamilAgentColors.vue"),
                meta: {
                    title: 'Famil Agent Colors'
                }
            },

            {
                path: 'agent-fonts',
                name: 'agent-fonts',
                component: () => import("@/components/admin/settings/AgentFonts.vue"),
                meta: {
                    title: 'Agent Fonts'
                }
            },

            {
                path: 'content-assessment',
                component: () => import("@/components/admin/ai/ContentAssessment.vue"),
                name: 'ai-content-assessment',
                meta: {
                    title: 'AI Content Assessment'
                }
            },

            {
                path: 'content-options',
                component: () => import("@/components/admin/content/ContentOptions.vue"),
                name: 'content-options',
                meta: {
                    title: 'Content Options'
                }
            },

            {
                path: 'content-process',
                component: () => import("@/components/admin/content-process/ContentProcessing.vue"),
                name: 'content-process',
                meta: {
                    title: 'Content Processing'
                }
            },

        ]
    },

    {
        path: '/app',
        component: () => import("@/components/user/UserDashboard.vue"),
        children: [

            {
                path: 'profile',
                name: 'agent-profile',
                component: () => import("@/components/user/profile/UserProfile.vue"),
                meta: {
                    title: 'My Profile'
                }
            },

            {
                path: 'users',
                name: 'agent-users',
                component: () => import("@/components/user/profile/UserList.vue"),
                meta: {
                    title: 'User List'
                }
            },

            {
                path: 'list-bookings',
                name: 'list-bookings',
                component: () => import("@/components/user/bookings/ListBookings.vue"),
                meta: {
                    title: 'My Bookings'
                }
            },

            {
                path: 'view-booking/:ref',
                name: 'view-booking',
                component: () => import("@/components/user/bookings/ViewBooking.vue"),
                meta: {
                    title: 'Booking Overview'
                }
            },

            {
                path: 'user-service-reviews',
                name: 'user-service-reviews',
                component: () => import("@/components/user/service-reviews/ReviewList.vue"),
                meta: {
                    title: 'Service Reviews'
                }
            },

            {
                path: 'user-alerts',
                name: 'user-alerts',
                component: () => import("@/components/user/alerts/AlertList.vue"),
                meta: {
                    title: 'Alerts & Announcements'
                }
            },

            {
                path: 'quick-quote',
                name: 'packages',
                //component: Packages,
                component: () => import("@/components/user/quick-quote/Packages.vue"),
                meta: {
                    title: 'Quick Quote'
                }
            },

            {
                path: 'quick-quote/:opt',
                name: 'package',
                //component: Package,
                component: () => import("@/components/user/quick-quote/Package.vue"),
                meta: {
                    title: 'Quick Quote'
                }
            },

            {
                path: 'quick-quote/customise/:ref',
                name: 'customise',
                component: () => import("@/components/user/quick-quote/Customise.vue"),
                meta: {
                    title: 'Quick Quote'
                }
            },

            {
                path: 'quick-quote/copy/:ref',
                name: 'copy',
                component: () => import("@/components/user/quick-quote/CopyQuote.vue"),
                meta: {
                    title: 'Quick Quote'
                }
            },

            {
                path: 'regular-tours-booking',
                name: 'regular-tours-booking',
                component: () => import("@/components/user/regular-tours/Booking.vue"),
                meta: {
                    title: 'Regular Tours Booking'
                }
            },

            {
                path: 'package-quotes',
                name: 'package-quotes',
                component: () => import("@/components/user/packages/Index.vue"),
                children: [
                    {
                        path: '',
                        name: 'package-list',
                        component: () => import("@/components/user/packages/PackageList.vue"),
                        meta: {
                            title: 'Packages'
                        }
                    },

                    {
                        path: 'make/:id',
                        name: 'quote-package',
                        component: () => import("@/components/user/packages/QuotePackage.vue"),
                        meta: {
                            title: 'Package Quote'
                        }
                    },

                    {
                        path: 'view/:id',
                        name: 'view-package-quote',
                        component: () => import("@/components/user/packages/PackageQuote.vue"),
                        meta: {
                            title: 'View Package Quote'
                        }
                    },
                ]
            },

            {
                path: 'product-search',
                name: 'product-search',
                component: () => import("@/components/user/Test.vue"),
                meta: {
                    title: 'Test Product Search'
                }
            },

            {
                path: 'terms-conditions',
                name: 'terms-conditions',
                component: () => import("@/components/user/TermsConditions.vue"),
                meta: {
                    title: 'Terms & Conditions'
                }
            },
        ]
    },

    {
        path: '/supplier-app',
        component: () => import("@/components/supplier/common-components/SupplierDashboard.vue"),
        children: [
            {
                path: 'profile',
                name: 'supplier-profile',
                component: () => import("@/components/supplier/profile/UserProfile.vue"),
                meta: {
                    title: 'My Profile'
                }
            },

            {
                path: 'terms',
                name: 'supplier-terms',
                component: () => import("@/components/supplier/SupplierTerms.vue"),
                meta: {
                    title: 'Supplier  Terms'
                }
            },

            {
                path: 'api-keys',
                name: 'supplier-api-keys',
                component: () => import("@/components/supplier/api-keys/ApiKeys.vue"),
                meta: {
                    title: 'API Keys'
                }
            },

            {
                path: 'users',
                name: 'supplier-users',
                component: () => import("@/components/supplier/profile/UserList.vue"),
                meta: {
                    title: 'User List'
                }
            },

            {
                path: 'requests',
                name: 'supplier-requests',
                component: () => import("@/components/supplier/requests/RequestsList.vue"),
                meta: {
                    title: 'Current Requests'
                }
            },

            {
                path: 'confirmed',
                name: 'supplier-confirmed',
                component: () => import("@/components/supplier/requests/ConfirmedList.vue"),
                meta: {
                    title: 'Confirmed Bookings'
                }
            },

            {
                path: 'cancelled',
                name: 'supplier-cancelled',
                component: () => import("@/components/supplier/requests/CancelledList.vue"),
                meta: {
                    title: 'Cancelled Bookings'
                }
            },

            {
                path: 'service/:id',
                name: 'supplier-service',
                component: () => import("@/components/supplier/SingleService.vue"),
                meta: {
                    title: 'Confirm Service'
                }
            },

            {
                path: 'supplier-series-tours',
                name: 'supplier-series-tours',
                component: () => import("@/components/supplier/series-tours/Index.vue")  ,
                children: [
                    {
                        path: '',
                        name: 'supplier-series-tour-list',
                        component: () => import("@/components/supplier/series-tours/SeriesTours.vue"),
                        meta: {
                            title: 'Series Tours'
                        }
                    },

                    {
                        path: ':id',
                        name: 'supplier-series-tour-requests',
                        component: () => import("@/components/supplier/series-tours/SeriesTourRequests.vue"),
                        meta: {
                            title: 'Series Tour Requests'
                        }
                    },

                    {
                        path: 'requests/:id',
                        name: 'supplier-series-tour-request',
                        component: () => import("@/components/supplier/series-tours/SeriesToursRequest2.vue"),
                        meta: {
                            title: 'Series Tour Request'
                        }
                    }
                ]
            },

        ]
    },

    {
        path: '/supplier/login',
        name: 'supplier-login',
        component: () => import("@/components/supplier/auth/Login.vue")
    },

    {
        path: '/supplier/service/:id',
        name: 'public-supplier-service',
        component: () => import("@/components/supplier/SingleServiceNoLogin.vue"),
        meta: {
            title: 'Confirm Service'
        }
    },

    {
        path: '/supplier/service-snapshot/:id',
        name: 'public-supplier-service-snapshot',
        component: () => import("@/components/supplier/SingleServiceSnapshot.vue"),
        meta: {
            title: 'Snapshot'
        }
    },

    {
        path: '/supplier/reconfirm/:id',
        name: 'public-supplier-reconfirm',
        component: () => import("@/components/supplier/SingleServiceReconfirmation.vue"),
        meta: {
            title: 'Reconfirm Service'
        }
    },

    {
        path: '/travel-app/:id',
        component: () => import("@/components/client/TravelApp.vue"),
        name: 'travel-app'
    },

    {
        path: '/famil/:id',
        component: () => import("@/components/client/FamilTravelApp.vue"),
        name: 'famil-travel-app'
    },

    {
        path: '/tour/proposal/:id',
        name: 'proposal',
        component: () => import("@/components/client/Proposal.vue"),
        meta: {
            title: 'Proposal'
        }
    },

    {
        path: '/tour/proposal/package/:id',
        name: 'package-proposal',
        component: () => import("@/components/client/Proposal.vue"),
        meta: {
            title: 'Proposal'
        }
    },

    {
        path: '/tour/confirmation/:id',
        name: 'confirmation',
        component: () => import("@/components/client/Confirmation.vue"),
        meta: {
            title: 'Confirmation'
        }
    },

    {
        path: '/tour/itinerary/:id',
        name: 'itinerary',
        component: () => import("@/components/client/Itinerary.vue"),
        meta: {
            title: 'Itinerary'
        }
    },

    {
        path: '/quote/:id',
        component: () => import("@/components/client/Quote.vue"),
        name: 'client-quote'
    },

    {
        path: '/travel-app/',
        component: FindTravelApp,
        name: 'find-travel-app'
    },

    {
        path: '/payments/:id',
        name: 'pay',
        component: () => import("@/components/payments/PaymentSession.vue"),
        meta: {
            title: 'Payment'
        }
    },

    {
        path: '/payments/result',
        name: 'payment-result',
        component: () => import("@/components/payments/PaymentResult.vue"),
        meta: {
            title: 'Payment'
        }
    },

    {
        path: '/touringco/:id?',
        name: 'touringco_customer',
        component: () => import("@/components/client/TouringCo.vue"),
        meta: {
            title: 'The NZ Touring Co Quotes'
        }
    }
]
const router = createRouter({
    history: createWebHistory(),
    routes,
    // linkActiveClass: "dark:bg-slate-800 bg-gray-200",
    // linkExactActiveClass: "dark:bg-slate-800 bg-gray-200",
    scrollBehavior() {
        // always scroll to top
        return { top: 0 }
      },
})

router.beforeEach((toRoute, fromRoute, next) => {
    window.document.title = toRoute.meta && toRoute.meta.title ? toRoute.meta.title : companyName;
    next();
})


router.onError((error, to) => {
    if (
        error.message.includes('Failed to fetch dynamically imported module') ||
        error.message.includes('Importing a module script failed')||
        error.message.includes('valid JavaScript MIME type')||
        error.message.includes('Unable to preload CSS')
    ) {
        if (!to?.fullPath) {
            window.location.reload();
        } else {
            window.location = to.fullPath;
        }
    }
})

export default router
